import React, { Fragment } from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { Row, Col, Container, Form } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min'
import { formatoMonto } from '../../common/Formatos'


const GrillaPretensionesImplicado = () => {
  const [data, setData] = useState(false)
  const data_administra_defensa = useSelector((state) => state.administracionCasoReducer)
  const { cfg_form39, listaPretensionesImplicados } = data_administra_defensa

  useEffect(() => {
    if (listaPretensionesImplicados && listaPretensionesImplicados.listaPretensionesImplicados && listaPretensionesImplicados.listaPretensionesImplicados.length > 0) {
      const objTotales = calculateTotales(listaPretensionesImplicados.listaPretensionesImplicados);
      setData([...listaPretensionesImplicados.listaPretensionesImplicados, objTotales]);
    }
  }, [listaPretensionesImplicados])

  const calculateTotales = (data) => {
    let totalEmergente = 0;
    let totalLucro = 0;
    let totalMoral = 0;
    let totalPasajero = 0;
    let totalImplicado = 0;

    data.forEach(pre => {
      totalEmergente += pre.monto_rcde;
      totalLucro += pre.monto_rclc;
      totalMoral += pre.monto_rcdm;
      totalPasajero += pre.monto_rcap;
      totalImplicado += pre.total;
    })

    return {
      id: "totales",
      nombre: "Total Implicados",
      monto_rcde: formatoMonto(totalEmergente),
      monto_rclc: formatoMonto(totalLucro),
      monto_rcdm: formatoMonto(totalMoral),
      monto_rcap: formatoMonto(totalPasajero),
      total: formatoMonto(totalImplicado),
      ultFechaRegistro: "",
    };
  }

  const obtenerColumnas = () => {
    return [
      {
        dataField: 'nombre',
        text: cfg_form39 ? cfg_form39.cfg_form39['modapretenciones-grilla-impl-implicado'] : '',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div className="table_header_font">
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: { backgroundColor: '#728bb0', color: 'white' }
      },
      {
        dataField: 'monto_rcde',
        text: cfg_form39 ? cfg_form39.cfg_form39['modapretenciones-grilla-impl-cobrcdem'] : '',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        formatter: (cell, row) => <span>{formatoMonto(row.monto_rcde, false)}</span>,
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div className="table_header_font">
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: { backgroundColor: '#728bb0', color: 'white' }
      },
      {
        dataField: 'monto_rclc',
        text: cfg_form39 ? cfg_form39.cfg_form39['modapretenciones-grilla-impl-cobrclc'] : '',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        formatter: (cell, row) => <span>{formatoMonto(row.monto_rclc, false)}</span>,
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div className="table_header_font">
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: { backgroundColor: '#728bb0', color: 'white' }
      },
      {
        dataField: 'monto_rcdm',
        text: cfg_form39 ? cfg_form39.cfg_form39[
          'modapretenciones-grilla-impl-cobrcdm'
        ] : '',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        formatter: (cell, row) => <span>{formatoMonto(row.monto_rcdm, false)}</span>,
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div className="table_header_font">
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: {
          backgroundColor: '#728bb0',
          color: 'white',
          verticalAlign: 'middle'
        }
      },
      {
        dataField: 'monto_rcap',
        text: cfg_form39 ? cfg_form39.cfg_form39[
          'modapretenciones-grilla-impl-cobrcap'
        ] : '',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        formatter: (cell, row) => <span>{formatoMonto(row.monto_rcap, false)}</span>,
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div className="table_header_font">
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: {
          backgroundColor: '#728bb0',
          color: 'white',
          verticalAlign: 'middle'
        }
      },
      {
        dataField: 'total',
        text: cfg_form39 ? cfg_form39.cfg_form39[
          'modapretenciones-grilla-impl-totalimpl'
        ] : '',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        formatter: (cell, row) => <span>{formatoMonto(row.total, false)}</span>,
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div className="table_header_font">
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: {
          backgroundColor: '#728bb0',
          color: 'white',
          verticalAlign: 'middle'
        }
      },
      {
        dataField: 'ultFechaRegistro',
        text: cfg_form39 ? cfg_form39.cfg_form39[
          'modapretenciones-grilla-impl-fechaultreg'
        ] : '',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div className="table_header_font">
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: {
          backgroundColor: '#728bb0',
          color: 'white',
          verticalAlign: 'middle'
        }
      },
    ]
  }

  return (
    <>
      <Container>
        <Row className='mt-2 mb-3'>
          <Col>
            <ToolkitProvider
              search
              bootstrap4
              keyField='id'
              data={data ? data : []}
              columns={obtenerColumnas()}
              defaultSorted={[{ dataField: 'secuencia', order: 'asc' }]}
            >
              {(props) => (
                <div>
                  {/* <Row>
                    <Col className="d-grid gap-2 d-md-flex justify-content-md-end mb-2">
                      <Form.Control placeholder="Buscar en la grilla" className="w-25" onChange={(e) => { props.searchProps.onSearch(e.target.value) }} />
                    </Col>
                  </Row> */}

                  <BootstrapTable
                    {...props.baseProps}
                    bordered={false}
                    headerWrapperClasses='table-secondary'
                    noDataIndication={
                      <div className='text-center'>
                        No hay registros encontrados
                      </div>
                    }
                  />
                </div>
              )}
            </ToolkitProvider>
          </Col>
        </Row>
      </Container>
      <style type='text/css'>
        {`
            .table_header_font {
              font-size: 15px;
            }
        `}
      </style>
    </>
  )
}

export default GrillaPretensionesImplicado
